import React, { useState, useEffect, useMemo } from 'react';
import { fetchJson } from '@utils/fetchJson';
import { useNotesStore } from './store/useNotesStore';
import { Loader2, Trash2, X } from 'lucide-react';
import { API_BASE_URL } from '@config';
import { format } from 'date-fns';
import {Dialog, TextEditor} from "@components/index";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { toast } from 'react-toastify';

const NotesPopup = ({ customer = {}, onClose }) => {
  const { isOpen, payload: payloadWrapper, close } = useNotesStore();
  const payload = useMemo(() => payloadWrapper?.payload || payloadWrapper || {}, [payloadWrapper]);
  const customerId = payload?.customer_id;
  const [update, setupdate] = useState(false);
  const [updateDel, setUpdateDel] = useState(false);
  
  const [notes, setNotes] = useState([]);
  const [selectedNote, setSelectedNote] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [followUp, setFollowUp] = useState(false);
  const [followUpDate, setFollowUpDate] = useState('');

  const fetchNotes = async () => {
    const res = await fetchJson(`${API_BASE_URL}/notes/list`, {
      method: 'POST',
      body: JSON.stringify({ customer_id: customerId }),
    });
    setupdate(false);
    setUpdateDel(false);
    setNotes(res?.flag === 'S' ? res.data : []);
  };

  useEffect(() => {
    if (customerId) fetchNotes();
    resetForm();

  }, [customerId]);

  const resetForm = () => {
    setSelectedNote(null);
    setTitle('');
    setDescription('');
    setFollowUp(false);
    setFollowUpDate('');
  };

  const handleNoteClick = (note) => {
    setSelectedNote(note);
    setTitle(note.title || '');
    setDescription(note.note_desc || '');
    setFollowUp(!!note.follow_up_date);
    setFollowUpDate(note.follow_up_date || '');
  };

  // const handleSave = async () => {
  //   setupdate(true);
  //   const noteType = followUp ? 'followup' : 'note';
  //   const payload = {
  //     note_id: selectedNote?.note_id || null,
  //     customer_id: customerId,
  //     note_desc: description,
  //     title,
  //     reminder_date: null,
  //     reminder_time: null,
  //     record_type: noteType,
  //     type: noteType,
  //     follow_up_date: followUp ? followUpDate : null,
  //     description,
  //   };

  //   const link = selectedNote?.note_id ? `${API_BASE_URL}/notes/${selectedNote?.note_id}`:`${API_BASE_URL}/notes`;
  //   await fetchJson(link, {
  //     method: selectedNote?.note_id ? 'POST' : "PUT",
  //     body: JSON.stringify(payload),
  //   });
  //   await fetchNotes();
  //   resetForm();
  // };

  const handleSave = async () => {
  // Trim title and extract clean description (strip html)
  const cleanTitle = title.trim();
  const cleanDesc = description.replace(/<[^>]*>/g, "").trim();

  // 1) Title required
  if (!cleanTitle) {
   toast.error(`Title cannot be empty.`);
   return;
  }

  // 2) Description required
  if (!cleanDesc) {
    toast.error(`Note description cannot be empty.`);
    return;
  }

  // 3) Follow-up date validation
  if (followUp) {
    if (!followUpDate) {
      toast.error(`Please select a follow-up date.`);
      return;
    }

    const selected = new Date(followUpDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selected < today) {
      alert("Follow-up date cannot be in the past.");
      return;
    }
  }

  // PROCEED only if valid
  setupdate(true);

  const noteType = followUp ? 'followup' : 'note';

  const payload = {
    note_id: selectedNote?.note_id || null,
    customer_id: customerId,
    note_desc: description,
    title,
    reminder_date: null,
    reminder_time: null,
    record_type: noteType,
    type: noteType,
    follow_up_date: followUp ? followUpDate : null,
    description,
  };

  const link = selectedNote?.note_id
    ? `${API_BASE_URL}/notes/${selectedNote?.note_id}`
    : `${API_BASE_URL}/notes`;

  await fetchJson(link, {
    method: selectedNote?.note_id ? 'POST' : "PUT",
    body: JSON.stringify(payload),
  });

  await fetchNotes();
  resetForm();
};
const MySwal = withReactContent(Swal);
  const handleDelete = async (note_id) => {
    const result = await MySwal.fire({
    title: 'Are you sure?',
    text: `Do you want to Delete these records?`,
    icon: 'warning',
    customClass: {
    title: 'swal2-title-lg',     // custom class for title
    popup: 'swal2-popup-md',     // for dialog box
    icon: 'swal2-icon-md',       // for the icon
    confirmButton: 'swal2-btn-lg', // for buttons
    cancelButton: 'swal2-btn-lg'
  },
    confirmButtonColor: '#2563eb', // Tailwind blue-600
    cancelButtonColor: '#64748b',  // Tailwind slate-500
    showCancelButton: true,
    confirmButtonText: `Yes, Delete`,
    width: 350,
  });
  if (result.isConfirmed) {

    //!selectedNote?.note_id
      setUpdateDel(true);
      if (!note_id) return;
      await fetchJson(`${API_BASE_URL}/notes/delete`, {
        method: 'POST',
        body: JSON.stringify({
          id:note_id,
        }),
      });
      await fetchNotes();
      resetForm();
    }
  };

  if (!isOpen) return null;

  return (
     <Dialog
          isOpen={isOpen}
          onClose={close}
          variant="custom"
          size="xl"
        >
    <div className="">
      <div className="relative bg-white w-full max-w-5xl h-[70vh] max-h-[600px] rounded-xl shadow-lg flex overflow-hidden">
        {/* Close Button */}
        {/* <button
          onClick={onClose}
          className="absolute right-3 top-3 z-20 bg-white w-8 h-8 rounded-full shadow flex items-center justify-center"
        >
          <X size={16} />
        </button> */}

        {/* Left Note List */}
        <div className="w-1/3 border-r bg-gray-50 flex flex-col overflow-y-auto">
  {/* Sticky Header */}
  <div className="sticky top-0 bg-gray-50 z-10 pb-2 pt-3 px-4 pb-4 mb-2 border-b">
    <h2 className="text-lg font-semibold">My Notes</h2>
    {/* <input
      type="text"
      placeholder="Search notes..."
      className="w-full mt-2 border px-3 py-2 rounded-md text-sm"
    /> */}
  </div>

  {/* Scrollable Notes List */}
  <div className="flex-1 overflow-y-auto px-2 pb-4">
    {notes.length === 0 ? (
      <p className="text-sm text-gray-500">No notes available.</p>
    ) : (
      <div className="space-y-2">
        {notes.map((note) => (
          <div key={note.note_id} onClick={() => handleNoteClick(note)} className="p-3 rounded-xl border cursor-pointer hover:bg-white bg-gray-100 relative">
            {/* Created Date at top right */}
            <div className="text-xs text-gray-400 absolute right-3 top-2">
                {note.created_date ? format(new Date(note.created_date), 'dd MMM') : ''}
            </div>

            {/* Title */}
            <h3 className="font-semibold text-sm mb-1 truncate pr-6">
                {note.title?.trim() || 'Untitled'}
            </h3>

            {/* Description */}
            <p className="text-xs text-gray-600 line-clamp-2 pr-4">
                {note.note_desc?.trim()
                ? <span dangerouslySetInnerHTML={{ __html: note.note_desc }} />
                : 'No description'}
            </p>

            {/* Follow-up */}
            {note.follow_up_date && (
                <p className="text-xs text-indigo-600 mt-2 pt-2 border-t border-gray-200">
                📅 Follow-up: {format(new Date(note.follow_up_date), 'dd MMM yyyy')}
                </p>
            )}
             <button
              className="absolute right-2 bottom-2 text-gray-400 text-sm underline hover:text-red-700"
              onClick={(e)=>{ e.stopPropagation(); handleDelete(note.note_id)}}
            >
              {updateDel ? (<Loader2 className="mr-2 h-4 w-4 animate-spin" /> ):(<Trash2 size={16}></Trash2>)}
            </button>
            </div>
        ))}
      </div>
    )}
  </div>
</div>

        {/* Right Editor Section */}
        <div className="w-2/3 flex flex-col h-full overflow-hidden">
  {/* Sticky Header */}
  <div className="sticky top-0 z-10 bg-white px-2 border-b">
    <input
  type="text"
  placeholder="Untitled"
  className="w-full px-4 py-3 h-[57px] focus:outline-none focus:ring-0 focus:border-gray-300"
  value={title}
  onChange={(e) => setTitle(e.target.value)}
/>
    {/* <h2 className="text-lg font-semibold">
      {selectedNote ? 'Edit Note' : 'Create New Note'}
    </h2> */}
  </div>

  {/* Scrollable Content */}
  <div className="flex-1 overflow-y-auto">
    {/* <div className="mb-4">
      <input
  type="text"
  placeholder="Untitled"
  className="w-full border rounded-md px-4 py-2"
  value={title}
  onChange={(e) => setTitle(e.target.value)}
/>
    </div> */}
    <div className="mb-4">
      <TextEditor
        fullHeight={true}
        value={description}
        showEditorInitially={true}
        onChange={setDescription}
        placeholder="Write your note here..."
      />
    </div>
  </div>

  {/* Sticky Footer */}
  <div className="sticky bottom-0 z-10 bg-white border-t px-6 py-4 flex flex-wrap justify-between items-center gap-4">
  {/* Follow-up reminder */}
  <div className="flex items-center gap-2">
    <label className="flex items-center gap-2 text-sm">
      <input
        type="checkbox"
        checked={followUp}
        onChange={(e) => setFollowUp(e.target.checked)}
      />
      Add follow-up reminder
    </label>
    {followUp && (
      <input
        type="date"
        className="border rounded-md px-2 py-1 text-sm"
        value={followUpDate}
        onChange={(e) => setFollowUpDate(e.target.value)}
      />
    )}
  </div>

  {/* Action buttons */}
  <div className="flex items-center gap-4 ml-auto">
    {/* {selectedNote && (
      <button
        className="text-red-500 text-sm underline hover:text-red-700"
        onClick={()=>handleDelete(selectedNote?.note_id)}
      >
        Delete Note
      </button>
    )} */}
    <button
      className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md"
      onClick={close}
    >
      Cancel
    </button>
    <button
      className="px-4 py-2 bg-blue-600 text-white rounded-md"
      onClick={handleSave}
    >
      {update ? "Wait..":"Save Note"}
    </button>
  </div>
</div>

</div>
      </div>
    </div>
    </Dialog>
  );
};

export default NotesPopup;
